import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';

import { Route, Redirect } from 'react-router-dom';

import { 	
	logIt, 
	getJsonFromUrl, 
	addCSSClass, 
	removeCSSClass, 
	replaceVars} from '__globals/global-functions';
	
import { fetchPromotion } from '_features/promotion/promotion-slice.js';

import { fetchGallery } from '_features/user-content/user-content-slice.js';

import { fetchEntryGroups } from '_features/entry-group/entry-group-slice.js';

export const Gallery = props => {
	
	const dispatch = useDispatch();
	
	const state = useSelector( state => state );
	logIt( "STATE at Gallery", state, true )
	
	const promotion = useSelector(state => state.promotion);
	logIt( "PROMOTION at Gallery", promotion, true );
	
	//const entryGroup = useSelector(state => state.entrygroup);
	//logIt( "ENTRYGROUP at ModerateImages", entryGroup, true );
	
	const gallery = useSelector(state => state.usercontent.gallery);
	logIt( "GALLERY at Gallery", gallery, true );
	
	const [galleryRetrieved, setGalleryRetrieved] = useState(false);
	const [previousGalleryLength, setPreviousGalleryLength] = useState(0);
	const [previousPage, setPreviousPage] = useState(0);
	const [page, setPage] = useState(0);
	const [size, setSize] = useState(100);
	const [items, setItems] = useState(undefined);
	
	const lostLinkWebsite = () => {
		window.location = promotion.configuration.promoCopy.GLOBAL.websiteLink;
	}

	const loadMore = () => {
		let p = page + 1;
		setPage(p);
		setGalleryRetrieved(false);
	}
	
	const getImages = () => {
		let items = gallery.map((image, key) => 
		{
			const imagePath = JSON.stringify({
				"bucket": "readysetpromo-images",
				"key": image.galleryImage,
				"edits": {
				  "resize": {
					"width": 400,
					"height": 400,
					"fit": "inside"
				  },
				  "rotate":null
				}
			});
			
			const imagePathEnc = window.btoa(imagePath);
			
			return (<div class='entry-photo'>
				<div class='photo-submission'>
					<div	aria-label={image.caption}
							class="hint--bottom">
						<img src={`https://d3acuqw8jjoosi.cloudfront.net/${imagePathEnc} `}/>
					</div>
				</div>
			</div>);
		});
		logIt( "ITEMS at Gallery", items, true );
		return items;
	}
	
	useEffect(() => {
		if ( 
			promotion.configuration.promoCopy !== undefined &&
			promotion.configuration.promoCopy.Gallery !== undefined &&
			promotion.configuration.promoCopy.Gallery.content !== undefined
		) {
			//let contentReplaced = replaceVars( promotion.configuration.promoCopy.Gallery.content, promotion )
			//document.getElementById("msg_content").innerHTML = contentReplaced;
		} else {
			//document.getElementById("msg_content").innerHTML = "Check back, the promotion is coming soon.";
		}
//		if ( promotion.configuration.config.entryGroupId ) {
//			//alert("getting entry groups")
//			dispatch( fetchEntryGroups( promotion.configuration.id, state.authentication.token ) );
//		}
		// TODO: handle this array more elegantly
		if ( (gallery === undefined) && (promotion.configuration.config.entryGroupId !== undefined) ) {
			//alert(entryGroup.entryGroups[0].id);
			dispatch( fetchGallery( promotion.configuration.config.entryGroupId, null, page, size ) );
		}
		if ( previousPage < page ) {
			setPreviousPage(page);
			dispatch( fetchGallery( promotion.configuration.config.entryGroupId, null, page, size ) );
		} else {
			if ( gallery !== undefined && !galleryRetrieved ) {
				let imgs = getImages();
				setItems( imgs );
				if ( gallery.length > previousGalleryLength ) {
					setGalleryRetrieved(true);
					setPreviousGalleryLength(gallery.length);
				}
			}
		}
	});
	
	return (
		    <React.Fragment>
		    {/*<TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title} />*/}
		<div id="gallery_page">
			
				<table border="0" cellpadding="0" cellspacing="0">
					<tr>
						<td className="page-visual">
							<div className="view-desktop"><img src={`https://readysetpromo.s3-us-west-2.amazonaws.com/${promotion.configuration.name}/images/${promotion.configuration.languagePath}desktop/gallery-screen.jpg`} /></div>
							<div className="view-phone" style={{display:'none'}}><img src={`https://readysetpromo.s3-us-west-2.amazonaws.com/${promotion.configuration.name}/images/${promotion.configuration.languagePath}phone/gallery-screen.jpg`} /></div>
						</td>
						<td className="page-content">       	

<div id='msg_content'>

<table border='0' cellPadding='0' cellSpacing='0' width='0'>
	<tr>
		<td>
			{/*<h1>{promotion.configuration.promoCopy.Gallery.title}</h1>*/}
			{/*<h2>{promotion.configuration.promoCopy.Gallery.instructions}</h2>*/}
			<div id='gallery'>
					    
{items}
			
			</div>
					    
		    <div class='gallery-load-more' onClick={loadMore} >
		        	<div class='view-desktop'><img src={`https://readysetpromo.s3-us-west-2.amazonaws.com/${promotion.configuration.name}/images/${promotion.configuration.languagePath}desktop/btn-gallery-load-more.png`} /></div>
		            <div class='view-mobile'><img src={`https://readysetpromo.s3-us-west-2.amazonaws.com/${promotion.configuration.name}/images/${promotion.configuration.languagePath}phone/btn-gallery-load-more.png`} /></div>
			</div>

		</td>
	</tr>
</table>

</div>
					    
						
						</td>
					</tr>
				</table>
			
		</div>
		</React.Fragment>
					
    );
    
}

